// /taskReducer.js

import {
  FETCH_TASKS_REQUEST,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILURE,
  CREATE_TASK_SUBMIT_REQUEST,
  CREATE_TASK_SUBMIT_SUCCESS,
  CREATE_TASK_SUBMIT_FAILURE,
  FETCH_APPROVED_TASKS_REQUEST,
  FETCH_APPROVED_TASKS_SUCCESS,
  FETCH_APPROVED_TASKS_FAILURE,
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_REJECTED_OR_PENDING_TASKS_REQUEST,
  FETCH_REJECTED_OR_PENDING_TASKS_SUCCESS,
  FETCH_REJECTED_OR_PENDING_TASKS_FAILURE,
  START_TASKS_REQUEST,
  START_TASKS_SUCCESS,
  START_TASKS_FAILURE,
  END_TASKS_REQUEST,
  END_TASKS_SUCCESS,
  END_TASKS_FAILURE,
  DO_LATER_TASKS_REQUEST,
  DO_LATER_TASKS_SUCCESS,
  DO_LATER_TASKS_FAILURE,
} from "../actions/taskActions";

const initialState = {
  loading: false,
  tasks: [],
  approvedTasks: [],
  rejectedOrPendingTasks: [],
  locations: [],
  error: null,
  createTaskStatus: null,
};

export const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    // 🔄 Fetch All Tasks
    case FETCH_TASKS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TASKS_SUCCESS:
      return { ...state, loading: false, tasks: action.payload };

    case FETCH_TASKS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // 📝 Create Task Submission
    case CREATE_TASK_SUBMIT_REQUEST:
      return { ...state, loading: true, error: null, createTaskStatus: null };

    case CREATE_TASK_SUBMIT_SUCCESS:
      return { ...state, loading: false, createTaskStatus: "success" };

    case CREATE_TASK_SUBMIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        createTaskStatus: "failure",
      };

    // ✅ Fetch Approved Tasks
    case FETCH_APPROVED_TASKS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_APPROVED_TASKS_SUCCESS:
      return { ...state, loading: false, approvedTasks: action.payload };

    case FETCH_APPROVED_TASKS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // 🚫⏳ Fetch Rejected or Pending Tasks
    case FETCH_REJECTED_OR_PENDING_TASKS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_REJECTED_OR_PENDING_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        rejectedOrPendingTasks: action.payload,
      };

    case FETCH_REJECTED_OR_PENDING_TASKS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // 📍 Fetch All Locations
    case FETCH_LOCATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LOCATIONS_SUCCESS:
      return { ...state, loading: false, locations: action.payload };

    case FETCH_LOCATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
      


    default:
      return state;
  }
};


